import type { DropdownMenuItem } from "../components/types";
import type { NotificationType } from "../shared/types/notificationSettingsTypes";

export const notificationTypes: {
  type: NotificationType;
  name: string;
  hint: string;
  onlyUsaVisible?: boolean;
}[] = [
  {
    type: "lastOrders",
    name: "campaign.notifications.lastOrders.title",
    hint: "campaign.notifications.lastOrders.description",
  },
  {
    type: "lastRegistrations",
    name: "campaign.notifications.lastRegistrations.title",
    hint: "campaign.notifications.lastRegistrations.description",
  },
  {
    type: "actualVisitors",
    name: "campaign.notifications.actualVisitors.title",
    hint: "campaign.notifications.actualVisitors.description",
  },
  {
    type: "visitorSummary",
    name: "campaign.notifications.visitorSummary.title",
    hint: "campaign.notifications.visitorSummary.description",
  },
  {
    type: "heureka",
    name: "campaign.notifications.heureka.title",
    hint: "campaign.notifications.heureka.description",
    onlyUsaVisible: false, // EU only - not visible in USA
  },
  {
    type: "zboziCompanyRating",
    name: "campaign.notifications.zbozi.title",
    hint: "campaign.notifications.zbozi.description",
    onlyUsaVisible: false, // EU only - not visible in USA
  },
  {
    type: "spolehlivaRecenzeShopRating",
    name: "campaign.notifications.spolehlivaRecenzeShopRating.title",
    hint: "campaign.notifications.spolehlivaRecenzeShopRating.description",
    onlyUsaVisible: false, // EU only - not visible in USA
  },
  {
    type: "individual",
    name: "campaign.notifications.individual.title",
    hint: "campaign.notifications.individual.description",
  },
  {
    type: "shoptetLastOrders",
    name: "campaign.notifications.shoptetLastOrders.title",
    hint: "campaign.notifications.shoptetLastOrders.description",
  },
  {
    type: "shoptetCouponCode",
    name: "campaign.notifications.shoptetCouponCode.title",
    hint: "campaign.notifications.shoptetCouponCode.description",
  },
  {
    type: "shopifyLastOrders",
    name: "campaign.notifications.shopifyLastOrders.title",
    hint: "campaign.notifications.shopifyLastOrders.description",
  },
  {
    type: "eshopRychleLastOrders",
    name: "campaign.notifications.eshopRychleLastOrders.title",
    hint: "campaign.notifications.eshopRychleLastOrders.description",
    onlyUsaVisible: false, // EU only - Czech e-commerce platform
  },
  {
    type: "googleReviews",
    name: "campaign.notifications.googleReviews.title",
    hint: "campaign.notifications.googleReviews.description",
  },
  {
    type: "trustpilotReviews",
    name: "campaign.notifications.trustPilot.title",
    hint: "campaign.notifications.trustPilot.description",
    onlyUsaVisible: true, // USA only - not visible in EU
  },
];

export const dropdownItems = [
  { title: "storeReview", value: "zboziCompanyRating" },
  { title: "productReview", value: "zboziProductRating" },
];

export const summaryModalDropdownItems = [
  { title: "visitors", value: "visitorSummary" },
  { title: "registrations", value: "registrationSummary" },
  { title: "orders", value: "orderSummary" },
];

export const saleType: DropdownMenuItem[] = [
  { title: "%", value: "%" },
  { title: "Kč", value: "Kč" },
  { title: "HUF", value: "HUF" },
  { title: "€", value: "€" },
  { title: "$", value: "$" },
];

export const daysDropdownItems = [
  { title: "days", value: "1" },
  { title: "days", value: "7" },
  { title: "days", value: "30" },
];
